function DummyCache() {}

DummyCache.prototype.get = function () {
  return null;
};

DummyCache.prototype.has = function () {
  return false;
};

DummyCache.prototype.set = function () {
};

module.exports = DummyCache;



//////////////////
// WEBPACK FOOTER
// /Users/Nathan/Desktop/Computing Sciences/dissertation/pairgo/pairgo-ng/~/idtoken-verifier/src/helpers/dummy-cache.js
// module id = ../../../../idtoken-verifier/src/helpers/dummy-cache.js
// module chunks = 4